import { z } from 'zod';
import { AuthorizedClient } from '~/app-modules/core/clients/authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import {
  BusinessAreaResponse,
  type TBusinessAreaResponse,
} from '~/app-modules/business-area/clients/dto/business-area-response';
import type { TCreateBusinessAreaRequest } from '~/app-modules/business-area/clients/dto/create-business-area-request';
import type { TUpdateBusinessAreaRequest } from '~/app-modules/business-area/clients/dto/update-business-area-request';
import { UserStore } from '~/app-modules/user/stores/user.store';

@singleton()
export class BusinessAreaClient extends AuthorizedClient {
  constructor(http: HttpConnection, authService: AuthService, userStore: UserStore) {
    super(http, authService, userStore);
  }

  async getById(id: string): Promise<TBusinessAreaResponse> {
    return await this.executeRequest(
      {
        method: 'get',
        url: `/ui/v1/business-area/${id}`,
      },
      BusinessAreaResponse,
    );
  }

  async getAvailableForCurrentUser(): Promise<TBusinessAreaResponse[]> {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/business-area/available-for-current-user',
      },
      z.array(BusinessAreaResponse),
    );
  }

  async update(updateBusinessAreaRequest: TUpdateBusinessAreaRequest): Promise<void> {
    return await this.executeRequest({
      method: 'put',
      url: '/ui/v1/business-area',
      data: updateBusinessAreaRequest,
    });
  }

  async create(createBusinessAreaRequest: TCreateBusinessAreaRequest): Promise<string> {
    return await this.executeRequest(
      {
        method: 'post',
        url: '/ui/v1/business-area',
        data: createBusinessAreaRequest,
      },
      z.string(),
    );
  }
}
